import { useEffect, useMemo, useState } from "react";
import { Circle, CircleMarker, MapContainer, TileLayer, Tooltip, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";

const MAP_STYLE = { width: "100%", height: "100%" };
const ACCURACY_STYLE = { color: '#2D4A3E', fillOpacity: 0.08, weight: 1 };
const MARKER_STYLE = { color: '#ffffff', fillColor: '#C65D3B', fillOpacity: 1, weight: 3 };

const MapPosition = ({ position }) => {
  const map = useMap();
  useEffect(() => { map.panTo([position.latitude, position.longitude]); }, [map, position.latitude, position.longitude]);
  useEffect(() => {
    map.getContainer().querySelectorAll('.leaflet-control a').forEach((el, i) => el.setAttribute('data-testid', `tracking-map-control-${i}`));
  }, [map]);
  return null;
};

export const TrackingMap = ({ position }) => {
  const [tileError, setTileError] = useState(false);
  const tileUrl = process.env.REACT_APP_MAP_TILE_URL;
  const attributionUrl = process.env.REACT_APP_MAP_ATTRIBUTION_URL;
  const handlers = useMemo(() => ({ tileerror: () => setTileError(true) }), []);
  const lat = position?.latitude, lng = position?.longitude;
  const point = useMemo(() => [lat, lng], [lat, lng]);
  if (!position) return null;
  if (!tileUrl || !attributionUrl) return <p role="alert" data-testid="tracking-map-config-error">Map is not configured. Location sharing status is still available.</p>;
  return (
    <div className="min-w-0" data-testid="tracking-map-section" data-latitude={position.latitude} data-longitude={position.longitude}>
      <div className="relative z-0 h-[340px] w-full overflow-hidden rounded-lg border border-ragi/20 sm:h-[440px]" data-lenis-prevent data-testid="tracking-map">
        <MapContainer center={point} zoom={15} scrollWheelZoom={false} style={MAP_STYLE}>
          <TileLayer url={tileUrl} maxZoom={19} referrerPolicy="strict-origin-when-cross-origin" attribution={`&copy; <a href="${attributionUrl}">OpenStreetMap contributors</a>`} eventHandlers={handlers} />
          <Circle center={point} radius={position.accuracy_m} pathOptions={ACCURACY_STYLE} />
          <CircleMarker center={point} radius={9} pathOptions={MARKER_STYLE}><Tooltip permanent direction="top">Latest rider location</Tooltip></CircleMarker>
          <MapPosition position={position} />
        </MapContainer>
      </div>
      {tileError && <p role="alert" className="mt-2 text-xs text-terracotta" data-testid="tracking-map-tile-error">Some map tiles could not load. The rider’s reported location is still available.</p>}
      <p className="mt-3 text-xs text-muted-foreground" data-testid="tracking-map-accuracy">GPS accuracy: approximately {Math.round(position.accuracy_m)} metres. Updated {new Date(position.captured_at).toLocaleTimeString()}.</p>
    </div>
  );
};